/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Grid, PageGridContainer } from '@coursera/cds-core';
import type { GridProps, Theme } from '@coursera/cds-core';

import TrackedDiv from 'bundles/page/components/TrackedDiv';
import Section from 'bundles/unified-description-page-common/components/shared/Section';

type Props = {
  cards: Array<React.ReactNode>;
};

const styles = {
  container: (theme: Theme) => css`
    contain: content;

    ${theme.breakpoints.down('xs')} {
      div:first-of-type {
        gap: ${theme.spacing(12)};
      }
    }
  `,
  card: css`
    justify-content: center;
    display: flex;
    margin: 0 auto;
  `,
};

const UpsellModule = ({ cards }: Props) => {
  if (!cards.length || cards.length > 3) {
    return null;
  }

  const md = (12 / cards.length) as GridProps['md'];

  return (
    <TrackedDiv
      trackingName="upsell_module"
      trackClicks={false}
      requireFullyVisible={false}
      withVisibilityTracking={true}
    >
      <Section>
        <PageGridContainer css={styles.container}>
          <React.Fragment>
            {cards.map((card) => {
              return (
                <Grid item key={cards.indexOf(card)} xs={12} md={md} css={styles.card}>
                  {/* @ts-expect-error TSMIGRATION-4.8 TS2769 */}
                  {React.isValidElement(card) && React.cloneElement(card, { amountOfCards: cards.length })}
                </Grid>
              );
            })}
          </React.Fragment>
        </PageGridContainer>
      </Section>
    </TrackedDiv>
  );
};

export default UpsellModule;
